import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FULFILLMENTS_VIEW_ID, FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID } from './view-id-constants';

export const FulfillmentsAdvancedSearch = {
  label: <FormattedMessage defaultMessage='Advanced Search' description='fulfillmentsPage.nav.advancedSearch' id='2G/ukT' />,
  id: FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/advanced-search',
  parentId: FULFILLMENTS_VIEW_ID,
};
